// import React, { useState, useEffect } from "react";
// import { Modal, Button } from "react-bootstrap";
// import { FiX } from "react-icons/fi";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   getViewProfile,
//   updateProfile,
// } from "../../../redux/slices/profileSlice";

// const AdditionalSpecialtiesModal = ({
//   show,
//   onHide,
//   value = [],
//   onSave,
//   isApplyPage = false,
//   shouldUpdateProfile = false,
// }) => {
//   const dispatch = useDispatch();
//   const store = useSelector((state) => state.profile);

//   const [selectedOptions, setSelectedOptions] = useState([]);
//   const [error, setError] = useState("");

//   // const specialtyOptions = [
//   //   { value: "Emergency Room (ER)", label: "Emergency Room (ER)" },
//   //   { value: "Operating Room (OR)", label: "Operating Room (OR)" },
//   //   { value: "Cardiac Care Unit (CCU)", label: "Cardiac Care Unit (CCU)" },
//   //   { value: "Medical-Surgical", label: "Medical-Surgical" },
//   // ];
//   const specialtyOptions = [
//     { value: "Emergency Room (ER)", label: "Emergency Room (ER)" },
//     { value: "Operating Room (OR)", label: "Operating Room (OR)" },
//     { value: "Cardiac Care Unit (CCU)", label: "Cardiac Care Unit (CCU)" },
//     { value: "Medical-Surgical", label: "Medical-Surgical" },
//     { value: "ICU", label: "Intensive Care Unit (ICU)" },
//     { value: "Pediatrics", label: "Pediatrics" },
//     { value: "NICU", label: "Neonatal Intensive Care Unit (NICU)" },
//     { value: "Telemetry", label: "Telemetry" },
//     { value: "Oncology", label: "Oncology" },
//     { value: "L&D", label: "Labor & Delivery (L&D)" },
//     { value: "Psych", label: "Psychiatric (Psych)" },
//     { value: "Rehab", label: "Rehabilitation (Rehab)" },
//     { value: "Case Management", label: "Case Management" },
//     { value: "Wound Care", label: "Wound Care" },
//     { value: "Other", label: "Other" },
//   ];

//   /* -------- LOAD EXISTING VALUES -------- */
//   useEffect(() => {
//     if (!show) return;

//     if (isApplyPage) {
//       setSelectedOptions(value || []);
//     } else {
//       const current =
//         store?.profileItem?.data?.nurseProfile?.additional_specialties;

//       if (current) {
//         let parsed = [];

//         try {
//           parsed = Array.isArray(current) ? current : JSON.parse(current);
//         } catch {
//           parsed = current.split(",");
//         }

//         setSelectedOptions(parsed);
//       }
//     }
//   }, [show, value, isApplyPage, store]);
//   // useEffect(() => {
//   //   if (!show) return;

//   //   if (isApplyPage) {
//   //     // ✅ APPLY PAGE
//   //     setSelectedOptions(value || []);
//   //   } else {
//   //     // ✅ PROFILE PAGE
//   //     const current =
//   //       store?.profileItem?.data?.nurseProfile?.additional_specialties;

//   //     if (current) {
//   //       let parsed = [];

//   //       try {
//   //         parsed = Array.isArray(current) ? current : JSON.parse(current);
//   //       } catch {
//   //         parsed = current.split(",");
//   //       }

//   //       setSelectedOptions(parsed);
//   //     }
//   //   }

//   //   // ❗ ONLY depend on show
//   // }, [show]);
//   /* -------- SELECT / DESELECT -------- */
//   // const handleSelect = (value) => {
//   //   setError("");

//   //   if (selectedOptions.includes(value)) {
//   //     setSelectedOptions(selectedOptions.filter((v) => v !== value));
//   //   } else {
//   //     setSelectedOptions([...selectedOptions, value]);
//   //   }
//   // };
//   const handleSelect = (value) => {
//     setError("");

//     setSelectedOptions((prev) =>
//       prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value],
//     );
//   };
//   /* -------- SAVE -------- */
//   const handleSave = () => {
//     if (!selectedOptions.length) {
//       setError("Please select at least one specialty");
//       return;
//     }

//     if (isApplyPage) {
//       // ✅ ALWAYS update local
//       onSave(selectedOptions);

//       // 🔥 ONLY call API if empty before
//       if (shouldUpdateProfile) {
//         const formData = new FormData();

//         formData.append(
//           "name",
//           store?.profileItem?.data?.name ||
//             store?.profileItem?.data?.full_name ||
//             "",
//         );

//         formData.append(
//           "additional_specialties",
//           JSON.stringify(selectedOptions),
//         );

//         dispatch(updateProfile(formData));
//       }

//       onHide();
//     } else {
//       // ✅ Profile page → always API
//       const formData = new FormData();

//       formData.append(
//         "name",
//         store?.profileItem?.data?.name ||
//           store?.profileItem?.data?.full_name ||
//           "",
//       );

//       formData.append(
//         "additional_specialties",
//         JSON.stringify(selectedOptions),
//       );

//       dispatch(updateProfile(formData));
//     }
//   };
//   // const handleSave = () => {
//   //   if (!selectedOptions.length) {
//   //     setError("Please select at least one specialty");
//   //     return;
//   //   }

//   //   if (isApplyPage) {
//   //     // ✅ LOCAL
//   //     onSave(selectedOptions);
//   //     onHide();
//   //   } else {
//   //     // ✅ API
//   //     const formData = new FormData();

//   //     formData.append(
//   //       "name",
//   //       store?.profileItem?.data?.name ||
//   //         store?.profileItem?.data?.full_name ||
//   //         "",
//   //     );

//   //     formData.append(
//   //       "additional_specialties",
//   //       JSON.stringify(selectedOptions),
//   //     );

//   //     dispatch(updateProfile(formData));
//   //   }
//   // };
//   /* -------- CLOSE AFTER SAVE -------- */
//   useEffect(() => {
//     if (store?.actionFlag === "PROFILE_UPDT_SCS") {
//       dispatch(getViewProfile());
//       onHide();
//     }
//   }, [store?.actionFlag]);
//   useEffect(() => {
//     if (show) {
//       // dispatch(getViewProfile());
//     }
//   }, [show, dispatch]);
//   return (
//     <Modal
//       show={show}
//       onHide={onHide}
//       centered
//       size="lg"
//       dialogClassName="custom-modal profile-other-details-modal"
//     >
//       <Modal.Header>
//         <h5 className="modal-title">Select Additional Specialties</h5>

//         <Button className="close-btn" onClick={onHide}>
//           <FiX size={24} />
//         </Button>
//       </Modal.Header>

//       <Modal.Body>
//         <div className="checkbox-options">
//           <div className="row">
//             {specialtyOptions.map((option) => (
//               <div
//                 key={option.value}
//                 className={`checkbox-option col-lg-6 ${
//                   selectedOptions.includes(option.value) ? "selected" : ""
//                 }`}
//                 onClick={() => handleSelect(option.value)}
//               >
//                 <div className="contentwrap">
//                   <input
//                     type="checkbox"
//                     checked={selectedOptions.includes(option.value)}
//                     readOnly
//                   />

//                   <label className="checkbox-label">{option.label}</label>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {error && <div className="error-message mt-2">{error}</div>}

//         <div className="text-center mt-4">
//           <Button
//             className="btn-primary px-4"
//             onClick={handleSave}
//             disabled={store?.isLoading}
//           >
//             {store?.isLoading ? "Saving..." : "Save"}
//           </Button>
//         </div>
//       </Modal.Body>
//     </Modal> <Modal
//       show={show}
//       onHide={onHide}
//       centered
//       size="lg"
//       dialogClassName="custom-modal profile-other-details-modal"
//     >
//       <Modal.Header>
//         <h5 className="modal-title">Select Additional Specialties</h5>

//         <Button className="close-btn" onClick={onHide}>
//           <FiX size={24} />
//         </Button>
//       </Modal.Header>

//       <Modal.Body>
//         <div className="checkbox-options">
//           <div className="row">
//             {specialtyOptions.map((option) => (
//               <div
//                 key={option.value}
//                 className={`checkbox-option col-lg-6 ${
//                   selectedOptions.includes(option.value) ? "selected" : ""
//                 }`}
//                 onClick={() => handleSelect(option.value)}
//               >
//                 <div className="contentwrap">
//                   <input
//                     type="checkbox"
//                     checked={selectedOptions.includes(option.value)}
//                     readOnly
//                   />

//                   <label className="checkbox-label">{option.label}</label>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {error && <div className="error-message mt-2">{error}</div>}

//         <div className="text-center mt-4">
//           <Button
//             className="btn-primary px-4"
//             onClick={handleSave}
//             disabled={store?.isLoading}
//           >
//             {store?.isLoading ? "Saving..." : "Save"}
//           </Button>
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default AdditionalSpecialtiesModal;
import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { updateProfile } from "../../../redux/slices/profileSlice";

const specialtyOptions = [
  "Emergency Room (ER)",
  "Operating Room (OR)",
  "Cardiac Care Unit (CCU)",
  "Medical-Surgical",
  "ICU",
  "Pediatrics",
  "NICU",
  "Telemetry",
  "Oncology",
  "L&D",
  "Psych",
  "Rehab",
  "Case Management",
  "Wound Care",
  "Other",
];

const SpecialtyModal = ({
  show,
  onHide,
  primaryValue,
  additionalValue = [],
  onSave,
  isApplyPage = false,
  shouldUpdateProfile = false,
}) => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);
  console.log(store, "mystoreeeee");

  const [primary, setPrimary] = useState("");
  const [primaryOther, setPrimaryOther] = useState("");

  const [additional, setAdditional] = useState([]);
  const [additionalOther, setAdditionalOther] = useState("");
  const [isInitialized, setIsInitialized] = useState(false);
  const [error, setError] = useState("");

  /* ---------- LOAD DATA ---------- */
  // useEffect(() => {
  //   if (!show) return;

  //   if (isApplyPage) {
  //     setPrimary(primaryValue || "");
  //     setAdditional(additionalValue || []);
  //   } else {
  //     const profile = store?.profileItem?.data?.nurseProfile;

  //     setPrimary(profile?.primary_specialty || "");

  //     let add = profile?.additional_specialties;
  //     if (add) {
  //       try {
  //         add = Array.isArray(add) ? add : JSON.parse(add);
  //       } catch {
  //         add = add.split(",");
  //       }
  //     }
  //     setAdditional(add || []);
  //   }
  // }, [show]);
  useEffect(() => {
    if (!show) {
      setIsInitialized(false); // reset when modal closes
      return;
    }

    if (isInitialized) return; // ✅ prevent override after user edits

    if (isApplyPage) {
      setPrimary(primaryValue || "");
      setAdditional(additionalValue || []);
    } else {
      const profile = store?.profileItem?.data?.nurseProfile;

      setPrimary(profile?.primary_specialty || "");

      let add = profile?.additional_specialties;

      if (add) {
        try {
          add = Array.isArray(add) ? add : JSON.parse(add);
        } catch {
          add = add.split(",");
        }
      }

      setAdditional(add || []);
    }

    setIsInitialized(true); // ✅ mark initialized
  }, [show, primaryValue, additionalValue, isApplyPage, store]);
  /* ---------- PRIMARY SELECT ---------- */
  const handlePrimaryChange = (value) => {
    setPrimary(value);
    setError("");

    if (value !== "Other") {
      setPrimaryOther("");
    }
  };

  /* ---------- ADDITIONAL SELECT ---------- */
  const handleAdditionalChange = (value) => {
    setError("");

    setAdditional((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value],
    );
  };

  /* ---------- SAVE ---------- */
  const handleSave = () => {
    let finalPrimary = primary === "Other" ? primaryOther.trim() : primary;

    let finalAdditional = [...additional];

    if (additional.includes("Other") && additionalOther.trim()) {
      finalAdditional = finalAdditional.filter((v) => v !== "Other");
      finalAdditional.push(additionalOther.trim());
    }

    if (!finalPrimary) {
      setError("Primary specialty is required");
      return;
    }

    // ✅ APPLY PAGE
    if (isApplyPage) {
      onSave({
        primary_specialty: finalPrimary,
        additional_specialties: finalAdditional,
      });

      if (shouldUpdateProfile) {
        const formData = new FormData();
        formData.append(
          "name",
          store?.profileItem?.data?.name ||
          store?.profileItem?.data?.full_name ||
          "",
        );
        formData.append("primary_specialty", finalPrimary);
        formData.append(
          "additional_specialties",
          JSON.stringify(finalAdditional),
        );

        dispatch(updateProfile(formData));
      }

      onHide();
    } else {
      // ✅ PROFILE PAGE
      const formData = new FormData();
      formData.append("primary_specialty", finalPrimary);
      formData.append(
        "additional_specialties",
        JSON.stringify(finalAdditional),
      );
      formData.append(
        "name",
        store?.profileItem?.data?.name ||
        store?.profileItem?.data?.full_name ||
        "",
      );
      dispatch(updateProfile(formData));
    }
  };

  /* ---------- CLOSE AFTER SAVE ---------- */
  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      onHide();
    }
  }, [store?.actionFlag]);
  const primaryOptions = specialtyOptions.map((opt) => ({
    value: opt,
    label: opt,
  }));
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">Select Specialties</h5>{" "}
        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />{" "}
        </Button>{" "}
      </Modal.Header>

      <Modal.Body>
        <div className="row">
          {/* LEFT: PRIMARY */}
          <div className="mb-2">
            <h6>Primary Specialty</h6>
            <Form.Group className="form-group">
              <Form.Label className="col-label">
                Select Primary Specialty
              </Form.Label>
              {/* <Select
                value={primary}
                onChange={(e) => handlePrimaryChange(e.target.value)}
              >
                <option value="">Select</option>
                {specialtyOptions.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </Select> */}
              <Select
                options={primaryOptions}
                value={primary ? { value: primary, label: primary } : null}
                onChange={(option) => {
                  handlePrimaryChange(option?.value || "");
                  setError("");
                }}
                isSearchable
                menuPosition="fixed"
                menuPortalTarget={document.body}
                styles={{
                  menu: (base) => ({
                    ...base,
                    borderRadius: "15px",
                    marginTop: "8px",
                    backgroundColor: "var(--mmp-surface)",
                    padding: "6px",
                    zIndex: "1000",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  option: (base, state) => ({
                    ...base,
                    borderRadius: "8px",
                    padding: "10px",
                    backgroundColor: state.isFocused ? "var(--mmp-hover-bg)" : "var(--mmp-surface)",
                    color: "var(--mmp-text-primary)",
                    cursor: "pointer",
                    "&:active": {
                      backgroundColor: "var(--mmp-hover-bg)",
                    },
                  }),
                }}
                placeholder="Select primary specialty..."
                className="react-select-container"
                classNamePrefix="react-select"
              />
            </Form.Group>

            {primary === "Other" && (
              // <Form.Control
              //   className="mt-2"
              //   placeholder="Enter specialty"
              //   value={primaryOther}
              //   onChange={(e) => setPrimaryOther(e.target.value)}
              // />
              <div className="form-group">
                <label className="col-label">Type Your Primary Specialty</label>
                <Form.Control
                  className={`col-input ${error ? "is-invalid" : ""}`}
                  placeholder="Enter specialty"
                  value={primaryOther}
                  onChange={(e) => setPrimaryOther(e.target.value)}
                />
              </div>
            )}
          </div>

          {/* RIGHT: ADDITIONAL */}
          <div>
            <h6>Additional Specialties</h6>

            <div className="checkbox-options">
              <div className="row">
                {specialtyOptions.map((opt) => (
                  <div
                    key={opt}
                    className={`checkbox-option col-12 col-sm-6 col-lg-6  ${additional.includes(opt) ? "selected" : ""
                      }`}
                    onClick={() => handleAdditionalChange(opt)}
                  >
                    <div className="contentwrap">
                      <input
                        type="checkbox"
                        checked={additional.includes(opt)}
                        readOnly
                      />
                      <label className="checkbox-label">{opt}</label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {error && <div className="text-danger mt-2">{error}</div>}

        <div className="text-center mt-4">
          <Button
            onClick={handleSave}
            disabled={
              store?.isLoading ||
              !primary ||
              (primary === "Other" && !primaryOther.trim())
            }
          >
            {store?.isLoading ? "Saving..." : "Save"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SpecialtyModal;
